var _circle, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#AF4356"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7,
    width: 20,
    height: 16.8,
    fill: "url(#pattern0_116_3866)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_116_3866",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_116_3866",
    transform: "scale(0.02 0.0238095)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_116_3866",
    width: 50,
    height: 42,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAqCAYAAADxughHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAARBSURBVHgB7VlbctNWGP5+yZ2Yt/SlMwGmhPcSRyuoWAFmBXVWELqCOCsoWQHuChJW4HQFUugCUKeXzPSF8AaDpcP3HyVBknWznSEW8M34onOk/5xP+u8SXOLsP/NMBPv8u43PAcEFDE5i4NDbkggrQvTr1bl5wZ8RbgMGF3GCx959CbECJDg3Ixd4gVuEAaLkHTzvoVxgSThOqk63ClF17mMXK6AnJi/AieF9cLH0nWkLJ8FzcfAkc+zz5xRLolcc+GlFXW2Ls3/Njd6sHtYEfDoPgr+NXzo5Q9hkP2tDhBi5vQrPyV2enZuItnRa5a4ddASSxjf1sK9J6qA43xkiWZDUmLFvGrw2m1dj66NajPQmwdvSKcGDkmHf3bDx76kerA0RE+NocE/GZXMM2ttUKZ9/VaW2rycEw4CplXdXnndCtdS4d7ZkQkN/zMMoO0eCB6pinbIRJWTJSCZgCzadDYw6Z+xKRtUwN2jgd9JrOU4+lWEwHXSSyKyPYhq13Uki3vfz6UoniZRhnZLGg1clqUdbfDFP5BuRdcPXaezBP2aXwchnNjrQY0bYt0mCU+9HOcEtoxURLUFZvalH8bPjwozNdbGv1RsPJ2zpHK3S0lkFjaqlHUiSmKJAIgut3rTYcfoINOVGA2xB5OBn3CBqifxJv041+g0tIWmqkKvcirAp9wamcsOt2UrV0jvLDuB4bsLgD1ZyoU2lBbsk+iQ7rRt0+5b8Xplc5w4Oir00Wx3GeInLWoMyfY4t9MSE0dRkB2KDXxEjdL9jB9JgmF1M55hGT7LnK2F2K4+Lm4tjEjH5IojHm5R7nBsyCBPB02JnhPsaQbWB16ANEarP1NTo/6edYW/nfp7EFYI3ZtN9hwCLq4stlKq68dybz71Nm4TwCYYOT/wdzYiqSCg0G+WdPcKiiOtfKTzaklNp0UY1Mxw5WguTzGHtiUkz2eQOJlgQfBqN7dnEWNupk3GoN9l6rcGW7V7sWUM2+CtXE7dEWY2gsrKfuYs+LNEsV8eQynspqVqOdfjaa+2kRqyfq7dX125X+7JN8jXq59aj3lKmlx2j3CjXo+pbm4pqBasTkcxhgsMB2z/F00rjCL1QWBA2bAp0vOZZ7hJTojYmr+9u2qeqhF2zEDgTKVfHUiJqZHMtF4PjqkBnA6eDX7JjcYkTYZ42KQz5ZxXFlA2cXLMQOCNP91YCQQWK6qWwr8hi6xhCq989RnIHoyIJXZBq9bBMboW7n8QzEp+lasbIP+TO9ueif00IqCRSs2g90sDpVbnV4H+z6yaMDS0D3TXoiHbuil81XZtrse2iDeIIbfEp+lde4/0goc0eFoDaWyz1b51riahLjfvwWga7KHasO5w0neilfVxVvajpXF07eV8d/a9Qq1pZ2JwqwZh2o+5wcLmIxoaQQWvi3VuuuNKcinKGot7pUt2s3AQnjouTRxXGXcRHZ321keMo45gAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScv);
export default __webpack_public_path__ + "static/media/SCV.20574a665298c26d7b3b5eed22d3307b.svg";
export { ForwardRef as ReactComponent };